import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "m-0 small text-secondary" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, [
  /*#__PURE__*/_createElementVNode("hr", { class: "w-100 m-2" })
], -1)
const _hoisted_3 = { class: "modal-row d-flex flex-row align-items-center" }
const _hoisted_4 = { class: "modal-row flex-grow-1 d-flex flex-column" }
const _hoisted_5 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_editable_title = _resolveComponent("editable-title")!
  const _component_city_night_count = _resolveComponent("city-night-count")!
  const _component_cost_display = _resolveComponent("cost-display")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_editable_title, {
      modelValue: _ctx.modelValue.name,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = name => _ctx.patchAndEmitCity({name}))
    }, null, 8, ["modelValue"]),
    _createElementVNode("p", _hoisted_1, "$" + _toDisplayString(_ctx.cityCost) + " total", 1),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_city_night_count, {
        modelValue: _ctx.modelValue,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = v => _ctx.$emit('update:modelValue', v))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_cost_display, {
        class: "flex-grow-1",
        cost: _ctx.modelValue.cost || 0,
        "onUpdate:cost": _ctx.scheduleCostUpdate
      }, null, 8, ["cost", "onUpdate:cost"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("textarea", {
        class: "form-control flex-grow-1",
        value: _ctx.modelValue.notes,
        onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.scheduleNoteUpdate && _ctx.scheduleNoteUpdate(...args))),
        placeholder: "Notes, Ideas, and More!"
      }, null, 40, _hoisted_5)
    ])
  ], 64))
}